/**
 * Analytics dashboard API - fetches GA4 data from backend
 */
import { api } from './api';

export const analyticsApi = {
  /**
   * GET /api/analytics/dashboard
   * @returns {Promise<{ success: boolean, configured: boolean, data: object | null, message?: string }>}
   */
  async getDashboard() {
    const { data } = await api.get('/analytics/dashboard');
    return data;
  },
};
